import { deleteData, getData, postData, putData } from '../plugins/ApiCalls'

const setupPath = (formId, variantId) => `forms/${formId}/variants/${variantId}/esign-agreements`

export function fetchEsignSetup(formId, variantId) {
  return getData(setupPath(formId, variantId))
}

export function createEsignAgreement(formId, variantId, agreement) {
  return postData(setupPath(formId, variantId), agreement)
}

export function updateEsignAgreement(formId, variantId, agreementId, agreement) {
  return putData(`${setupPath(formId, variantId)}/${agreementId}`, agreement)
}

export function deleteEsignAgreement(formId, variantId, agreementId) {
  return deleteData(`${setupPath(formId, variantId)}/${agreementId}`)
}

export function setEsignAgreementActive(formId, variantId, agreementId, isActive) {
  return putData(`${setupPath(formId, variantId)}/${agreementId}/active`, { is_active: isActive })
}

export function reorderEsignAgreements(formId, variantId, ids) {
  return putData(`${setupPath(formId, variantId)}/order`, { ids })
}

export function fetchEsignDrafts() {
  return getData('esign/drafts')
}

// One Submission's agreements: history, what a send by hand would fill, send by hand, signed PDF.
const leadPath = (formId, leadId) => `forms/${formId}/leads/${leadId}/esign-agreements`

export function fetchLeadAgreements(formId, leadId) {
  return getData(leadPath(formId, leadId))
}

export function fetchLeadSendOptions(formId, leadId) {
  return getData(`${leadPath(formId, leadId)}/send-options`)
}

export function sendLeadAgreement(formId, leadId, payload) {
  return postData(leadPath(formId, leadId), payload)
}

export function fetchSignedPdf(formId, leadId, recordId) {
  return getData(`${leadPath(formId, leadId)}/${recordId}/pdf`)
}
